import type { ExtendedPartTagType } from '@/entities/rubrics';
import { moreValue } from '@/widgets/rubricsBlock/lib/consts';

/**
 * Обрезает список чипов до maxCount (+ «Ещё», если его нет в первых maxCount).
 * Выбранная рубрика остаётся на месте, если уже в первых maxCount;
 * иначе подставляется перед «Ещё» (19 обычных + выбранная + «Ещё»).
 */
export function trimVisibleRubricsChips(
  tags: ExtendedPartTagType[],
  maxCount: number,
  selectedSlug?: string | null,
): ExtendedPartTagType[] {
  if (tags.length <= maxCount) {
    return tags;
  }

  const lastTag = tags[tags.length - 1];
  const moreTag = lastTag?.value === moreValue ? lastTag : undefined;
  const selectedTag =
    selectedSlug && selectedSlug !== 'all'
      ? tags.find((tag) => tag.value !== moreValue && tag.value === selectedSlug)
      : undefined;

  const isSelectedInHead = selectedTag && tags.slice(0, maxCount).some((tag) => tag.value === selectedSlug);

  if (!selectedTag || isSelectedInHead) {
    const trimmed = tags.slice(0, maxCount);
    const needsMoreAppend = moreTag && !trimmed.some((tag) => tag.value === moreValue);

    return needsMoreAppend ? [...trimmed, moreTag] : trimmed;
  }

  const withoutSelectedAndMore = tags.filter((tag) => tag.value !== moreValue && tag.value !== selectedSlug);

  return [...withoutSelectedAndMore.slice(0, maxCount - 1), selectedTag, ...(moreTag ? [moreTag] : [])];
}
